import { PermissionRow } from '@capturi/core'

export const getOtherPermissions = (): PermissionRow[] => {
  const rows: PermissionRow[] = [
    {
      name: 'Playback Audio',
      key: 'playback',
      description:
        'Permission to play conversations within Conversational Intelligence. This does not affect access to library snippets.',
    },
    {
      name: 'Download',
      key: 'download',
      description:
        'Permission to download audio (conversations and library snippets) directly from the Conversational Intelligence user interface. Requires the ‘Playback Audio’ permission.',
    },
    {
      name: 'View Reports',
      key: 'viewReports',
      description:
        'Allows the user to view tailor made reports for your organisation',
    },
    {
      name: 'Hide Agent Information',
      key: 'hideUserInfo',
      description: 'Permission to hide agent names and e-mails.',
    },
    {
      name: 'Archive',
      key: 'archive',
      description: 'Permission to show archive',
    },
  ]

  return rows
}
